import {
    Component, Input, OnInit
} from "@angular/core";

import { Observable } from 'rxjs';

import {
    Unit, UnitMonthlyCut, UnitMonthlyCutProviders
} from '../../../../../../_models';
import { MonthlyCut } from '../../../../../../_models/Classes';

@Component({
    selector: 'app-units-monthly-cut',
    templateUrl: './units-monthly-cut.component.html',
    providers: [UnitMonthlyCutProviders]
})

export class UnitsMonthlyCutComponent implements OnInit {
    @Input() monthlyCut: MonthlyCut;
    searchReq$: Observable<any>;
    params: string = 'include=unit,investor';
    unitTexts = {
        label: "Número oficial",
        notFound: "unidad no encontrada",
        loading: "Cargando unidades...",
        none: "Ninguna unidad"
    };
    additionalEntry = 'Todas';
    constructor(
        private data: UnitMonthlyCut,
        private unitData: Unit
    ) { }
    ngOnInit() {
        this.data.getAll(this.monthlyCut.id, this.params).subscribe(monthlyCuts => { });
    }

    unitFilterChange(unit) {
        let urlParams = `${this.params}`;
        if (unit != this.additionalEntry) urlParams = `${urlParams}&iid=${unit.id}`;
        this.searchReq$ = this.data.getAll(this.monthlyCut.id, urlParams);
    }
    performSearch() {
        this.searchReq$.subscribe(data => { });
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/monthly-cut/monthly-cut-detail/units-monthly-cut/units-monthly-cut.component.ts